import { Semaphore } from 'semaphore';

export default class SemaphoreHelper {
  static use(sem: Semaphore, f: () => Promise<void>): Promise<void> {
    return new Promise((resolve, reject) => {
      sem.take(async () => {
        try {
          await f();
          resolve();
        } catch (err) {
          console.error(err);
          reject();
        } finally {
          sem.leave();
        }
      });
    });
  }
}
